import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box
} from '@mui/material';
import InvoiceViewDialog from '../InvoiceViewDialog';
import ValidationErrorDialog from '../common/ValidationErrorDialog';

function SalesDialogs({
  viewInvoiceDialog,
  onCloseViewDialog,
  selectedInvoice,
  viewInvoiceLoading,
  deleteDialogOpen,
  onCancelDelete,
  onConfirmDelete,
  invoiceToDelete,
  printConfirmOpen,
  onClosePrintConfirm,
  onConfirmPrint
}) {
  return (
    <>
      {/* View Invoice Dialog */}
      <InvoiceViewDialog
        open={viewInvoiceDialog}
        onClose={onCloseViewDialog}
        invoice={selectedInvoice}
        loading={viewInvoiceLoading}
      />

      {/* Delete Confirmation Dialog */}
      <ValidationErrorDialog
        open={deleteDialogOpen}
        title="Delete Draft Invoice"
        message="Are you sure you want to delete this draft invoice? This action cannot be undone."
        onConfirm={onConfirmDelete}
        onCancel={onCancelDelete}
      />

      {/* Print Confirmation Dialog */}
      <Dialog
        open={printConfirmOpen}
        onClose={onClosePrintConfirm}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Print Invoice</DialogTitle>
        <DialogContent>
          Would you like to print this invoice?
        </DialogContent>
        <DialogActions>
          <Button onClick={onClosePrintConfirm}>Cancel</Button>
          <Button onClick={onConfirmPrint} variant="contained" color="primary">
            Print
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default React.memo(SalesDialogs); 